import { render, staticRenderFns } from "./ManualEnrollment.vue?vue&type=template&id=fff2e49c&scoped=true&"
import script from "./ManualEnrollment.vue?vue&type=script&lang=js&"
export * from "./ManualEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff2e49c",
  null
  
)

export default component.exports